import React, { useEffect, useRef } from 'react';
import './starry-background.css';

const StarryBackground: React.FC = () => {
    const starsRef = useRef<HTMLDivElement>(null);
    const numberOfStars = 500;

    useEffect(() => {
        const starsElement = starsRef.current;

        if (starsElement) {
            const createStar = () => {
                const starEl = document.createElement('span');
                starEl.className = 'star';
                const minSize = 1;
                const maxSize = 2;
                const size = Math.random() * (maxSize - minSize) + minSize;
                starEl.style.width = `${size}px`;
                starEl.style.height = `${size}px`;
                starEl.style.left = `${Math.random() * 100}%`;
                starEl.style.top = `${Math.random() * 100}%`;
                starEl.style.animationDelay = `${Math.random() * 10}s`;
                starsElement.appendChild(starEl);
            };

            for (let i = 0; i < numberOfStars; i++) {
                createStar();
            }
        }

        return () => {
            if (starsElement) {
                while (starsElement.firstChild) {
                    starsElement.removeChild(starsElement.firstChild);
                }
            }
        };
    }, []);

    return <div className="stars" ref={starsRef}></div>;
};

export default StarryBackground;
